export async function sniperAnimation(k, victim) {
    // Initial Reload & Breath
    k.play("sniper_reload", { volume: 0.5 });
    await k.wait(1);

    const initialScale = 0.9;
    const scalegap = 0.2;
    const finalX = victim.pos.x;
    const finalY = victim.pos.y;
    const startY = finalY + 40;

    // Create target sprite for animation
    const sniperTarget = k.add([
        k.sprite("targetCursorOn"),
        k.pos(finalX, finalY - 40),
        k.anchor("center"),
        k.color(255, 0, 0),
        k.scale(initialScale),
        k.opacity(0),
        k.z(2000)
    ]);

    // Fade In wihtout waiting
     k.tween(0, 1, 0.3, (v) => sniperTarget.opacity = v, k.easings.linear);

    // Searching phase
    const searchDuration = 2.5;
    const searchRadius = 200;
    const swings = 2;

    await k.tween(0, 1, searchDuration, (t) => {
        // Shrink radius as it focuses
        const currentRadius = searchRadius * (1 - k.easings.easeOutQuad(t));

        // Chaotic math
        const offsetX = Math.sin(t * Math.PI * 2 * swings) * currentRadius;
        const offsetY = Math.cos(t * Math.PI * 4 * swings) * currentRadius;

        // Smoothly slide base position up
        const currentBaseY = startY - (40 * k.easings.easeOutQuad(t));

        sniperTarget.pos = k.vec2(finalX + offsetX, currentBaseY + offsetY);
        sniperTarget.scale = k.vec2(initialScale - (scalegap * t));
    }, k.easings.linear);

    // Lock-on
    sniperTarget.pos = k.vec2(finalX, finalY);
    sniperTarget.scale = k.vec2(initialScale - scalegap);

    await k.tween(
        initialScale - scalegap,
        initialScale - (scalegap * 2),
        scalegap,
        (v) => sniperTarget.scale = k.vec2(v),
        k.easings.easeOutBack
    );

    // The Shot
    k.play("sniper_shoot", { volume: 0.5 });
    await k.wait(0.3);

    sniperTarget.destroy();
}